import React from "react";
import cx from "classnames";
import { Reveal } from "src/components/reveal";

import { ReactComponent as HowItWorksArrow } from "../../images/svg/HowItWorksArrow.svg";
import { ReactComponent as DownArrow } from "../../images/svg/DownArrow.svg";

import styles from "./how-it-works.module.css";

interface HowItWorksProps {
  module: {
    headline?: string;
    steps: any;
    stepStyle?: string;
  };
}
export const HowItWorks = ({ module }: HowItWorksProps) => {
  const { headline, steps, stepStyle } = module;
  return (
    <div className={cx(styles.howItWorks)}>
      <h2 className={cx("subhead ac", styles.headline)}>{headline}</h2>
      <div
        className={cx(
          styles.steps,
          stepStyle === "outlined" ? styles.outlined : styles.solid
        )}
      >
        {steps &&
          steps.map((step, index) => (
            <div className={styles.step} key={index}>
              <Reveal delay={(index + 1) * 120} threshold={0.5}>
                <div className={styles.stepInner}>
                  <div className={styles.stepNumberContainer}>
                    <span className={cx("headline", styles.stepNumber)}>
                      {index + 1}
                    </span>
                    {index + 1 !== steps.length && (
                      <div className={styles.mobileArrow}>
                        <DownArrow />
                      </div>
                    )}
                  </div>
                  <div className={styles.stepCopy}>
                    <p className={cx("body", styles.stepTitle)}>{step.title}</p>
                    <p className={cx("body", styles.stepSubtitle)}>
                      {step.subtitle}
                    </p>
                  </div>
                </div>
              </Reveal>
              {index + 1 !== steps.length && (
                <div className={styles.arrow}>
                  <HowItWorksArrow />
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};
